import React, { useRef } from 'react';
import classnames from 'classnames';

// Components
import WpChoice from '../choice/WpChoice';

// Styles
import './WpToggleSwitch.scss';

export type Size = 'sm' | 'md';

export interface Props {
  /** ID for the input */
  id: string;
  /** Initial value for the input */
  // value: string;
  /** Name for form input */
  name?: string;
  /** Additional hint text to display */
  descriptionText?: string;
  /** Radio button is selected */
  checked?: boolean;
  /** Label for the input */
  label: string;
  /** Disable the input */
  disabled?: boolean;
  /** Callback when value is changed */
  onChange?(value: boolean): void;
  // size?: Size;
}

const WpToggleSwitch: React.FC<Props> = ({
  id,
  // value,
  name,
  descriptionText,
  label,
  checked,
  disabled,
  onChange,
}: // size = 'sm',
Props) => {
  const size = 'sm';
  const optionLabels = ['yes', 'no'];

  const inputNode = useRef<HTMLInputElement>(null);

  const handleOnClick = () => {
    if (onChange) {
      onChange(inputNode.current.checked);
      inputNode.current.focus();
    }
  };

  const handleKeyPress = e => {
    if (e.keyCode !== 32) return;

    handleOnClick();
  };

  const baseClassName = 'WpToggleSwitch';
  const classes = classnames(baseClassName, `${baseClassName}--${size}`);

  // eslint-disable-next-line
  function noop() {}
  function stopPropagation(event: React.MouseEvent | React.KeyboardEvent | React.FormEvent) {
    event.stopPropagation();
  }

  return (
    <WpChoice id={id} label={label} descriptionText={descriptionText} onClick={handleOnClick}>
      <div className={classes}>
        <input
          ref={inputNode}
          type="checkbox"
          name={name}
          className={`${baseClassName}-checkbox`}
          id={id}
          checked={checked}
          onChange={noop}
          disabled={disabled}
        />
        {id ? (
          <label
            className={`${baseClassName}-label`}
            tabIndex={disabled ? -1 : 1}
            onKeyDown={e => handleKeyPress(e)}
            htmlFor={id}
            onClick={stopPropagation}
          >
            <span
              className={disabled ? `${baseClassName}-inner ${baseClassName}-disabled` : `${baseClassName}-inner`}
              data-yes={optionLabels[0]}
              data-no={optionLabels[1]}
              tabIndex={-1}
            />
            <span
              className={disabled ? `${baseClassName}-switch ${baseClassName}-disabled` : `${baseClassName}-switch`}
              tabIndex={-1}
            />
          </label>
        ) : null}
      </div>
    </WpChoice>
  );
};

export default WpToggleSwitch;
